// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilterButton_wrapper__0QT_L","clear":"FilterButton_clear__On43n","default":"FilterButton_default__icRuI"};